module.exports = __webpack_public_path__ + "img/probg.2f9241d9.jpg";